import * as React from 'react';
import './Admin.less';
import { Form, Input, Button, Checkbox, Divider, message, Spin, Select, Row, Col } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import { withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';

import Users from './Users';
import { UsersProps } from './Users';
import AddClassroomDTO from 'src/models/classroom/AddClassroomDTO';
import UpdateClassroomDTO from 'src/models/classroom/UpdateClassroomDTO';
import KeyValueListDTO from 'src/models/generic/KeyValueListDTO';
import KeyValueDTO from 'src/models/generic/KeyValueDTO';
import ClassroomApiController from 'src/api/ClassroomApiController';
import UserApiController from 'src/api/UserApiController';
import KeyValuePairDTO from "src/models/admin/KeyValuePairDTO";


interface RouteParams {
    id: string;
}

interface AddEditClassroomProps extends PageProps<RouteParams>, LocalizeContextProps { }

interface AddEditClassroomState {
    loading: boolean;
    isSubmitting: boolean;
    currentClassroom: UpdateClassroomDTO;
    teacherCounselorsAtSchool: KeyValueDTO<number, string>[];
    shouldRefreshTable: boolean;
}

interface ClassroomFormProps {
    currentClassroom: UpdateClassroomDTO;
    teacherCounselorsAtSchool: KeyValueDTO<number, string>[];
    translate: (id: any) => any;
    onChange: (changedFields: any[]) => void;
}

// Form
let ClassroomForm = Form.create({
    onFieldsChange(props: ClassroomFormProps, changedFields: any[]) {
        props.onChange(changedFields);
    }
})(class extends React.Component<ClassroomFormProps & FormComponentProps> {
    constructor(props: ClassroomFormProps & FormComponentProps) {
        super(props);
    }

    private generateOptionsForSelect(keyValues: KeyValueDTO<number, string>[]): JSX.Element[] {
        return keyValues.map(keyValue => <Select.Option value={keyValue.key} key={keyValue.key} title={keyValue.value}>{keyValue.value}</Select.Option>);
    }

    private renderStandardFormItem(translationId: string, id: string, initialValue, inputType, visible: boolean = true, required: boolean = true) {
        let translatedLabel = this.props.translate(translationId);

        if (visible) {
            return (
                <Form.Item label={translatedLabel}>
                    {this.props.form.getFieldDecorator(id, {
                        initialValue: initialValue,
                        rules: [{ required: required, message: this.props.translate('admin.common.requiredRule') }]
                    })(inputType)}
                </Form.Item>
            );
        }
    }

    render() {
        return (
            <Row>
                <Col span={12}>
                    <Form className="admin-form">
                        {this.renderStandardFormItem(
                            "admin.addEditClassroom.formItem1",
                            "classroomName",
                            this.props.currentClassroom.classroomName,
                            <Input autoComplete="off" />
                        )}

                        {this.renderStandardFormItem(
                            "admin.addEditClassroom.formItem2",
                            "selectedTeacherCounselorAdminIds",
                            this.props.currentClassroom.selectedTeacherCounselorAdminIds,
                            <Select optionFilterProp="title" mode="multiple">{this.generateOptionsForSelect(this.props.teacherCounselorsAtSchool)}</Select>,
                            this.props.currentClassroom.showTeacherCounselorAdminSelect,
                            false
                        )}
                    </Form>
                </Col>
            </Row>
        );
    }
});

class AddEditClassroom extends React.Component<AddEditClassroomProps, AddEditClassroomState> {
    formRef: React.Component<FormComponentProps>;

    constructor(props: AddEditClassroomProps) {
        super(props);
        bindAllOfThis(this, AddEditClassroom.prototype);

        let classroomId = parseInt(this.props.match.params.id, 10);

        let currentClassroom: UpdateClassroomDTO = {
            classroomId: classroomId,
            classroomName: "",
            showTeacherCounselorAdminSelect: false,
            selectedTeacherCounselorAdminIds: []
        };

        this.state = {
            loading: true,
            isSubmitting: false,
            shouldRefreshTable: false,
            teacherCounselorsAtSchool: [],
            currentClassroom: currentClassroom
        };
    }

    componentWillMount() {
        UserApiController.getTeacherCounselorAdminsForSchool().then((result) => {
            this.setState({
                teacherCounselorsAtSchool: result.data
            }, this.fillForm);
        }).catch(e => {
            message.error(this.props.translate('admin.common.messageTeacherCounselorAdminsError'));
        });
    }

    private fillForm(): void {
        let classroomId = this.state.currentClassroom.classroomId ? this.state.currentClassroom.classroomId : 0;

        ClassroomApiController.getClassroom(classroomId).then((result) => {
            this.setState({
                loading: false,
                currentClassroom: result.data
            });
        }).catch(e => {
            message.error(this.props.translate('admin.addEditClassroom.messageRetrieveError'));
        });
    }

    private handleInputChange(changedFields: any[]): void {
        let newState = {};
        for (var key in changedFields) {
            if (changedFields.hasOwnProperty(key)) {
                let field: any = changedFields[key];
                newState[key] = field.value;
            }
        }

        this.setState({
            currentClassroom: { ...this.state.currentClassroom, ...newState }
        });
    }

    private addClassroom(): void {
        let addClassroomDTO: AddClassroomDTO = {
            classroomName: this.state.currentClassroom.classroomName,
            selectedTeacherCounselorAdminIds: this.state.currentClassroom.selectedTeacherCounselorAdminIds
        };

        ClassroomApiController.addClassroom(addClassroomDTO)
            .then(result => {
                message.success(this.props.translate('admin.addEditClassroom.messageAdd'));
                this.setState({ isSubmitting: false });
                this.props.history.push(Routes.getRoute(Routes.ADMIN_ADD_EDIT_CLASSROOM, result.data));
            }).catch(e => {
                message.error(this.props.translate('admin.addEditClassroom.messageAddError'));
                this.setState({ isSubmitting: false });
            });
    }

    private updateClassroom(): void {
        ClassroomApiController.updateClassroom(this.state.currentClassroom)
            .then(result => {
                message.success(this.props.translate('admin.addEditClassroom.messageUpdate'));
                this.setState({ isSubmitting: false });
            }).catch(e => {
                message.error(this.props.translate('admin.addEditClassroom.messageUpdateError'));
                this.setState({ isSubmitting: false });
            });
    }

    private handleSubmit(e): void {
        e.preventDefault();

        this.formRef.props.form.validateFields((error: any, values: any) => {
            if (!error) {
                this.setState({ isSubmitting: true });
                this.state.currentClassroom.classroomId ? this.updateClassroom() : this.addClassroom();
            }
        });
    }

    private handleCancel(e): void {
        this.props.history.push(Routes.ADMIN_CLASSROOMS);
    }

    private updateShouldRefreshTable(): void {
        this.setState({ shouldRefreshTable: !this.state.shouldRefreshTable });
    }

    private renderStudents(): JSX.Element {
        let classroomUsersProps: UsersProps = {
            classroomId: this.state.currentClassroom.classroomId,
            onlyClassroomUsers: true,
            updateShouldRefreshTable: this.updateShouldRefreshTable,
            shouldRefreshTable: this.state.shouldRefreshTable,
            history: this.props.history,
            location: this.props.location
        } as UsersProps;

        let allUsersProps: UsersProps = {
            classroomId: this.state.currentClassroom.classroomId,
            onlyClassroomUsers: false,
            updateShouldRefreshTable: this.updateShouldRefreshTable,
            shouldRefreshTable: this.state.shouldRefreshTable,
            history: this.props.history,
            location: this.props.location
        } as UsersProps;

        if (this.state.currentClassroom.classroomId) {
            return (
                <div>
                    <Users {...classroomUsersProps} />
                    <br /><br />
                    <Users {...allUsersProps} />
                </div>
            );
        }
    }

    render() {
        if (this.state.loading) {
            return <Spin />;
        }

        let formProps = {
            currentClassroom: this.state.currentClassroom,
            teacherCounselorsAtSchool: this.state.teacherCounselorsAtSchool,
            translate: this.props.translate,
            onChange: this.handleInputChange
        } as ClassroomFormProps;

        return (
            <div>
                <h2>
                    {this.state.currentClassroom.classroomId ?
                        this.state.currentClassroom.classroomName :
                        this.props.translate('admin.addEditClassroom.addHeader')}
                </h2>

                <ClassroomForm wrappedComponentRef={ref => this.formRef = ref} {...formProps} />

                <div>
                    <Button type="primary" onClick={this.handleSubmit} loading={this.state.isSubmitting}>
                        {this.props.translate("admin.common.saveButton")}
                    </Button>
                    <Divider type="vertical" />
                    <Button onClick={this.handleCancel}>
                        {this.props.translate("common.back")}
                    </Button>
                </div>

                <br /><br />

                {this.renderStudents()}

            </div>
        );
    }
}

export default withLocalize(AddEditClassroom);



// WEBPACK FOOTER //
// ./src/pages/admin/AddEditClassroom.tsx